import Alpine from "alpinejs";

export function renderSections(sections) {
	Object.entries(sections).forEach(([id, markup]) => {
		const selector = `[data-id="${id}"]`;

		const source = new DOMParser()
			.parseFromString(markup, "text/html")
			.querySelector(selector);

		if (!source) return;

		document.querySelectorAll(selector).forEach((el) => {
			Alpine.destroyTree(el);
			const fresh = source.cloneNode(true);
			el.replaceWith(fresh);
			Alpine.initTree(fresh);
		});
	});

	return Promise.resolve();
}
